import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilitiesService } from '../utilities/utilities.service';

@Injectable({
  providedIn: 'root'
})
export class CreateRequestService {
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),

  };
  constructor(private http: HttpClient, private UTS: UtilitiesService) { }

  getRetrieveCustomer(accountNumber, token) {
    const payload = { "accountNumber": accountNumber, "token": token };
    return this.http.post(
      `${environment.BASE_URL}/retrieveCustomer`,
      payload,
      this.httpOptions
    );
  }

  
  createRequest(data, token) {
    const payload = { ...data, "token": token};
    const createRequestHeaders = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      'Accept-Encoding': 'UTF-8',
      'Accept': 'application/json'
    });
    return this.http.post(
      `${environment.BASE_URL}/createRequest`,
      payload,
      {headers: createRequestHeaders}
    );
  }
}